<div class="spinner-center" *ngIf="loading">
    <mat-spinner></mat-spinner>
</div>

<div class="document-div" *ngIf="!loading">
    <mat-card *ngIf="!disabled" class="form-card">
        <mat-card-header>
            <mat-card-title>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.DOCS_TO_TRANSFER.NEW_ITEM' | translate
                }}</mat-card-title>
            <div class="action-buttons">
                <button mat-raised-button color="primary" (click)="addDocument()" [disabled]="formGroup.invalid"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.DOCS_TO_TRANSFER.ADD_ITEM' | translate">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="formGroup">
                <div class="formDiv">
                    <mat-form-field class="w100 mb5" *ngIf="udeuService.isRequired('order', formGroup)">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.ORDER' |
                            translate
                            }}</mat-label>
                        <input matInput formControlName="order">
                        <mat-hint>001-01</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w100" *ngIf="udeuService.isRequired('directory', formGroup)">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.DIRECTORY' |
                            translate
                            }}</mat-label>
                            <input matInput formControlName="directory">
                    </mat-form-field>

                    <mat-form-field class="w100">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.TITLE' |
                            translate
                            }}</mat-label>
                        <input matInput formControlName="title">
                    </mat-form-field>

                    <mat-form-field class="w100">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.CONTENT' |
                            translate
                            }}</mat-label>
                        <input matInput formControlName="content">
                    </mat-form-field>

                    <smt-date-input class="w45" [group]="formGroup" [controlName]="'date'" [dateType]="DateType.YEAR"
                        [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.DATE_FROM'"></smt-date-input>
                        
                    <smt-date-input class="w45" [group]="formGroup" [controlName]="'dateTo'" [dateType]="DateType.YEAR"
                        [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.DATE_TO'"></smt-date-input>
                </div>
            </form>
        </mat-card-content>
    </mat-card>

    <form [formGroup]="group" [ngClass]="!disabled ? 'w50' : 'w100'" *ngIf="formArray.controls.length > 0">
        <div [formArrayName]="controlName">
            <mat-accordion>
                <div class="accordion-div" *ngFor="let control of formArray.controls; let i = index"
                    [formGroupName]="i">
                    <mat-expansion-panel #panel class="expansion-panel"
                        [expanded]="i === formArray.controls.length-1 && formArray.controls.length === 1">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span>
                                    <span *ngIf="control.get('code').value && control.get('signatura').value">
                                        ({{control.get('code').value}}) {{control.get('signatura').value}} - 
                                    </span>
                                    <span>
                                        {{control.get('order').value}}{{control.get('directory').value}} /
                                        {{control.get('title').value}}
                                    </span>
                                </span>
                            </mat-panel-title>
                            <mat-panel-description>
                                <mat-icon>description</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="div-wrap">
                            <mat-form-field class="w100 mb5" *ngIf="control.get('order').value">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.ORDER'
                                    |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="order">
                                <mat-hint *ngIf="!disabled">001-01</mat-hint>
                            </mat-form-field>

                            <mat-form-field class="w100" *ngIf="control.get('directory').value as value">
                                <mat-label>{{
                                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.DIRECTORY' |
                                    translate
                                    }}</mat-label>
                                    <div *ngIf="actionType === TransferActionTypes.ViewTransfer || actionType === TransferActionTypes.CatalogTransfer">
                                        <a *ngIf="isUrl(value)" [href]="value">  {{ value }} </a>
                                        <span *ngIf="!isUrl(value)">  {{ value }} </span>
                                    </div>
                                    <input [hidden]="actionType === TransferActionTypes.ViewTransfer || actionType === TransferActionTypes.CatalogTransfer" matInput formControlName="directory">
                            </mat-form-field>

                            <mat-form-field class="w100">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.TITLE'
                                    |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="title">
                            </mat-form-field>

                            <mat-form-field class="w100">
                                <mat-label>{{
                                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.CONTENT' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="content">
                            </mat-form-field>

                            <smt-date-input class="w45" [group]="formArrayGroup(i)" [controlName]="'date'" [dateType]="DateType.YEAR"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.DATE_FROM'"></smt-date-input>
                                
                            <smt-date-input class="w45" [group]="formArrayGroup(i)" [controlName]="'dateTo'" [dateType]="DateType.YEAR"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.DATE_TO'"></smt-date-input>

                            <mat-form-field [matTooltip]="'DEUSTO.TOOLTIPS.EDIT_CATALOG' | translate" class="w45" *ngIf="canEditExtraProps || control.get('code').value">
                                <mat-label>{{
                                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.CODE' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="code">
                            </mat-form-field>

                            <mat-form-field  [matTooltip]="'DEUSTO.TOOLTIPS.EDIT_CATALOG' | translate" class="w45" *ngIf="canEditExtraProps || control.get('signatura').value">
                                <mat-label>{{
                                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.DOCS_TO_TRANSFER.SIGNATURA' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="signatura">
                            </mat-form-field>
                        </div>

                        <div class="action-buttons" *ngIf="!disabled">
                            <button mat-raised-button color="warn" (click)="delete(i)"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.DOCS_TO_TRANSFER.DELETE_ITEM' | translate">
                                <mat-icon>delete</mat-icon> {{ 'APP.ACTIONS.DELETE' | translate }}
                            </button>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
        </div>
    </form>

    <mat-card *ngIf="formArray.controls.length == 0" class="center">
        <mat-card-content>
            {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.DOCS_TO_TRANSFER.EMPTY_ITEM' | translate }}
        </mat-card-content>
    </mat-card>
</div>